import store from "../store";
import { sessionActions } from "../store";

export const deleteSession = () => {

    store.dispatch(sessionActions.updateTokenExpired(true));
}